import { distributionReportRelevantStatHierarchy,
    DistributionReportStat } from '../../../Common/TargetingShared/model/statisticsReport/distribution-report-stat-api.model';
import { EmailEventApiModel } from '../../../api/distributions/model/email-event.api.model';
import { RecipientSearchResultApiModel } from '../../../api/distributions/model/recipient-search-results.api.model';
import { TargetingResultModel } from './targeting-result.model';
import { HandleApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { EntityType } from '../../../api/targeting/enum/entity.type.enum';
import { EmploymentModel } from './employment.model';
export class RecipientResultModel extends TargetingResultModel {
    // TODO : make FE model?
    events?: EmailEventApiModel[];
    topStat?: DistributionReportStat;
    handles?: HandleApiModel[];
    isAdditionalRecipient?: boolean = false;
    distributedEmail?: string;
    relevantNegativeStat?: DistributionReportStat;

    constructor(apiModel?: RecipientSearchResultApiModel) {
        super(apiModel);

        this.distributedEmail = apiModel.distributedEmail;
        this.events = [...apiModel.events];

        if (apiModel.entityType === EntityType.CONTACT) {
            this.handles = [...apiModel.contactInfo.handles];
            this.selectedEmployment = new EmploymentModel(apiModel?.employments.pop());
        } else {
            this.handles = [...apiModel.outletInfo.handles];
        }


        const allEventTypes: DistributionReportStat[] = this.events.map(event => event.type);
        // Find the first (ie., highest priority) relevant stat in the event list
        const priorityStat = distributionReportRelevantStatHierarchy.find(relevantStat =>
            allEventTypes.find(eventType => eventType === relevantStat)
        );
        // Fall back to PENDING if no other stat found
        this.topStat = priorityStat ?? DistributionReportStat.PENDING;
        this.relevantNegativeStat = distributionReportRelevantStatHierarchy.find(stat => stat === apiModel.relevantNegativeStat);
    }
}
